import type { Data, Route, Routes } from '@angular/router';
import { ReportingComparisonScopes } from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ProductionReportViewerPageComponent } from '../../components/production-report-viewer-page/production-report-viewer-page.component';
import { ProductionComparisonDashboardComponent, ProductionHistoryDashboardComponent } from '../production-dashboards';
import { ReportsViewerComponent } from './reports-viewer.component';
import {
  REPORTS_VIEWER_COMPARISON_ROUTE_PATH,
  REPORTS_VIEWER_PRODUCTION_HISTORY_ROUTE_PATH,
} from './reports-viewer-routing.constants';

export type ReportsViewerRoutesOptions = {
  /** The app's own guard for every reports route. */
  canActivate?: Route['canActivate'];
  /** Route data for the report page, e.g. `{ saveDefaultsOnApply: true, useStoredDefaults: true }` in ARM. */
  reportPageData?: Data;
  /** Tab title for `comparison-dashboard/:scope`. */
  comparisonDashboardTitle?: Route['title'];
  /** Tab title for `production-history/:scope`. */
  productionHistoryTitle?: Route['title'];
  /** Tab title for `:reportId`, for example `mga-paid`. */
  reportPageTitle?: Route['title'];
};

/**
 * The reports routes, defined once for both apps: tiles, a report page, and the comparison and
 * production tracking dashboards for a scope. Each app mounts them under its own path with its
 * own guard.
 */
export function buildReportsViewerRoutes({
  canActivate = [],
  reportPageData = {},
  comparisonDashboardTitle,
  productionHistoryTitle,
  reportPageTitle,
}: ReportsViewerRoutesOptions = {}): Routes {
  return [
    {
      path: `${REPORTS_VIEWER_COMPARISON_ROUTE_PATH}/:scope`,
      component: ProductionComparisonDashboardComponent,
      canActivate,
      title: comparisonDashboardTitle,
    },
    {
      path: `${REPORTS_VIEWER_PRODUCTION_HISTORY_ROUTE_PATH}/:scope`,
      component: ProductionHistoryDashboardComponent,
      canActivate,
      title: productionHistoryTitle,
    },
    // Links from before scopes existed; that page only ever showed the company-wide view.
    {
      path: REPORTS_VIEWER_PRODUCTION_HISTORY_ROUTE_PATH,
      redirectTo: `${REPORTS_VIEWER_PRODUCTION_HISTORY_ROUTE_PATH}/${ReportingComparisonScopes.allianceGroup}`,
      pathMatch: 'full',
    },
    {
      path: ':reportId',
      component: ProductionReportViewerPageComponent,
      canActivate,
      data: reportPageData,
      title: reportPageTitle,
    },
    { path: '', component: ReportsViewerComponent, pathMatch: 'full', canActivate },
  ];
}
